import logo from './logo.svg';
import './App.css';
import NewGameMap from './gamemap';
import {useState} from "react";

function App() {
    return (
        <div className="App">
            <NewGameMap/>
        </div>
    );
}

export default App;
